export default __webpack_public_path__ + "static/Visual-4ead8f8926220c01c097fa6222befd6e.png";